// Generated by scripts/fetch-laws.ts from lawsofux.com and timsommer.be. Do not edit directly.
import type { Law } from "../types";

export const mooresLaw: Law = {
  slug: "moores-law",
  title: "Moore's Law",
  definition: "The power of computers per unit cost doubles every 24 month.",
  category: "theory",
  color: "#c8bc00",
  labels: ["cs"],
  copy: ["The most popular version states:","Or"],
  sources: ["https://www.timsommer.be/famous-laws-of-software-development/"],
  related: [],
};
